import { create } from 'zustand';

interface AuthState {
  /** Az Odin iam access-token — CSAK memóriában (XSS-védelem); reload után a refresh-cookie állítja vissza. */
  token: string | null;
  setToken: (token: string) => void;
  logout: () => void;
}

/**
 * Auth-állapot (zustand, memory-only — NINCS localStorage). A refresh-token httpOnly cookie-ban él
 * (a JS nem éri el); oldal-újratöltéskor a `tryRefresh` (lib/auth.ts) szerzi vissza az access-tokent.
 */
export const useAuthStore = create<AuthState>()((set) => ({
  token: null,
  setToken: (token) => {
    set({ token });
  },
  logout: () => {
    set({ token: null });
  },
}));
